import store from "../store";
import { ResolveBaseApiUrl } from "../utils/Utility";
import APIService from "./APIService";

const baseUrl = ResolveBaseApiUrl() + "Notifications/";
const notificationAPIService = new APIService(baseUrl);

export async function GetNotifications() {
  var url = `getnotifications?userid=${store.getState().auth.user.userid}`;
  return await notificationAPIService.fetchData(url);
}

export async function GetNotificationUnreadCount() {
  var url = `getunreadnotificationcount?userid=${
    store.getState().auth.user.userid
  }`;
  return await notificationAPIService.fetchData(url);
}

export async function MarkNotificationRead() {
  var url = `marknotificationread?userid=${store.getState().auth.user.userid}`;
  return await notificationAPIService.fetchData(url);
}
